import { render } from "./padel-upload.template.html?vue&type=template&id=5818e0b2&scoped=true"
import script from "./PadelUpload.vue?vue&type=script&lang=ts"
export * from "./PadelUpload.vue?vue&type=script&lang=ts"

import "./PadelUpload.vue?vue&type=style&index=0&id=5818e0b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5818e0b2"

export default script